import * as React from "react";
import { Button, Flex, GridItem } from "@chakra-ui/react";
import { BiEditAlt } from "react-icons/bi";
import { Grid, InputView } from "components";
import { Types } from "../../duck";

interface ViewProps {
  admin: Types.Admin;
  onEdit(): void;
}

const View: React.FC<ViewProps> = ({ admin, onEdit }) => (
  <Flex>
    <Grid flex={1}>
      <GridItem>
        <InputView label="First Name" value={admin.firstName} />
      </GridItem>

      <GridItem>
        <InputView label="Last Name" value={admin.lastName} />
      </GridItem>

      <GridItem>
        <InputView label="Email" value={admin.email} />
      </GridItem>

      <GridItem>
        <InputView label="Password" value="*******" />
      </GridItem>

      <GridItem>
        <InputView label="Pin" value="*******" />
      </GridItem>

      <GridItem>
        <InputView label="Picture" value={admin?.image?._id} type="image" />
      </GridItem>
    </Grid>
    <Button leftIcon={<BiEditAlt />} onClick={onEdit} colorScheme="minor">
      Edit
    </Button>
  </Flex>
);

export default View;
